import React from 'react';
import { Navigate,useLocation  } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, userProfile, isAdmin, loading } = useAuth();
  const location = useLocation();

  // Wait for Firebase to resolve before making any redirect decision
  if (loading) return null;

  // Check if user exists
  if (!user) {
    // Save the intended destination
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  
  // Check email verification
  if (!user.emailVerified) {
    return <Navigate to="/login" replace />;
  }
  
  // Check admin access
  if (adminOnly && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default ProtectedRoute;